<template lang="pug">
  footer#footer
    b-nav(align="center", small)
      b-nav-item(href="/tos.pdf", target="_blank", link-classes="border-right") 利用規約
      b-nav-item(href="http://www.neo.co.jp/terms.html", target="_blank", link-classes="border-right") ご利用にあたって
      b-nav-item(href="http://www.neo.co.jp/privacy/", target="_blank") 個人情報保護方針
    b-nav(align="center", small)
      b-nav-text Copyright © 2022 NEOJAPAN Inc. All Rights Reserved.
</template>

<script>
export default {
  name: "FooterMenu",
}
</script>

<style scoped>
#footer {
  margin-top: 30px;
  padding: 10px;
  text-align: center;
  border-top: black 1px solid;
}
</style>
